const config = {
    appUrl : "http://localhost:3000",
    // apiUrl : "https://api.webweb.ai"
    apiUrl : "https://clockyapi.skyq.tech"
}
  
export default config